import React from 'react';
import { isColorDark } from '../utils';

const VariantSelectors = ({ groups, selectedVariants, onSelectVariant, accentColor, theme }) => (
  <div className="space-y-4" data-testid="variant-selectors">
    {groups.map(group => (
      <div key={group.id}>
        <h3 className="text-sm font-semibold mb-2.5">
          {group.name}
          {selectedVariants[group.id] && (
            <span className="font-normal ml-2" style={{ color: theme.mutedText }}>: {selectedVariants[group.id].name}</span>
          )}
        </h3>
        <div className="flex flex-wrap gap-2">
          {(group.options || []).map(option => {
            const isSelected = selectedVariants[group.id]?.id === option.id;
            const hasImage = !!option.imageUrl;
            
            if (hasImage) {
              return (
                <button
                  key={option.id}
                  onClick={() => onSelectVariant(group.id, option)}
                  className="relative w-14 h-14 rounded-lg overflow-hidden border-2 transition-all"
                  style={{
                    borderColor: isSelected ? accentColor : theme.borderColor,
                    boxShadow: isSelected ? `0 0 0 1px ${accentColor}` : 'none'
                  }}
                  title={option.name}
                  data-testid={`variant-option-${option.id}`}
                >
                  <img 
                    src={`${process.env.REACT_APP_BACKEND_URL}${option.imageUrl}`}
                    alt={option.name}
                    className="w-full h-full object-cover"
                  />
                </button>
              );
            }
            
            return (
              <button
                key={option.id}
                onClick={() => onSelectVariant(group.id, option)}
                className="px-4 py-2 rounded-lg text-sm font-medium border-2 transition-all"
                style={{
                  borderColor: isSelected ? accentColor : theme.borderColor,
                  backgroundColor: isSelected ? accentColor : 'transparent',
                  color: isSelected ? (isColorDark(accentColor) ? '#fff' : '#000') : theme.textColor
                }}
                data-testid={`variant-option-${option.id}`}
              >
                {option.name}
              </button>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);

export default VariantSelectors;
